import React, { useEffect } from 'react';
import { sendTrackingInfo, ModalCreditsOptions } from '@panel/commons';
import { useTranslation } from 'react-i18next';

function OnHoldToOnCreditsYes(props) {
  const { onClickAction, onClickSelect, onClickCancel, plans, defaultPlan, isInmobiliaria } = props;
  const { t } = useTranslation();

  useEffect(() => {
    const txt = `'Republicar Aviso en Espera_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}-Intencion`;
    sendTrackingInfo('Mis avisos', txt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickAction = e => {
    const txt = `Republicar Aviso en Espera con credito_Publicar_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickAction(e);
  };

  const handleClickCancel = () => {
    const txt = `Republicar Aviso en Espera con credito_Cancelar_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickCancel();
  };

  return (
    <ModalCreditsOptions
      onClickCancel={handleClickCancel}
      onClickAction={e => handleClickAction(e)}
      onClickSelect={onClickSelect}
      onClickOutside={handleClickCancel}
      defaultPlan={defaultPlan}
      plans={plans}
      title={t('panel.modal.OnHoldToOn.title')}
      subTitle={t('panel.modal.OnHoldToOn.subtitle')}
      ctaCancel={t('panel.modal.cta.wait')}
      ctaOk={t('panel.modal.cta.publishNow')}
    />
  );
}

export { OnHoldToOnCreditsYes };
